import { isValidElement } from 'react';
import styled from 'styled-components';
import { Label } from '../Label/Label';

const LabelValueElement = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
`;

const LabelWrapper = styled.div`
  box-sizing: border-box;
  min-width: 150px;
  padding-right: 50px;
`;

const Value = styled.div<IProps>`
  word-break: break-all;
  ${({ value, variation, theme }) =>
    !isValidElement(value) &&
    `
    color: ${variation === 'form' ? theme.vars.newColor.darkGS1 : theme.vars.color.pink};
    font-weight: ${variation === 'form' ? 600 : null}
  `}
`;

export type LabelValueVariation = 'form';

interface IProps {
  /** Label of the value */
  label?: string;
  /** The value */
  value?: JSX.Element | string;
  /** Variation: `form` */
  variation?: LabelValueVariation;
}

export const LabelValue = ({ label, value, variation }: IProps) => (
  <LabelValueElement data-testid="LabelValue">
    <LabelWrapper>
      <Label name={`${label}:`} variation={variation} />
    </LabelWrapper>

    <Value value={value} variation={variation}>
      {value}
    </Value>
  </LabelValueElement>
);
